// extracted by mini-css-extract-plugin
export var active = "_8y-2";
export var recordingDot = "_8y-1";
export var recordingIndicator = "_8y-0";